module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Light-Italic.228c7e8.woff2";